import React from "react";
import { makeStyles } from "@mui/styles";
import Paper from "@mui/material/Paper";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { negociosSegurosOptions } from "~constants/negocios";
import { TabItem } from "../types";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexGrow: 1,
    width: "100%",
    borderRadius: "8px  8px  0px 0px ",
    borderBottom: "solid 1px #CCCCE4",
    justifyContent: "center",
  },
  tab: {
    minWidth: "160px",
    fontWeight: 800,
    "&.Mui-selected": {
      color: theme.palette.primary.main,
      fontWeight: 800,
    },
  },
}));

interface TabSelectorProps {
  list: TabItem[];
  value?: string;
  onChange?: (newValue: string) => void;
}

const TabSelector: React.FC<TabSelectorProps> = ({ list, value, onChange }) => {
  const classes = useStyles();

  const handleChange = (_event: React.SyntheticEvent, newValue: string) => {
    if (onChange) onChange(newValue);
  };

  return (
    <Paper className={classes.root}>
      {value && (
        <Tabs
          key={"TabSelector"}
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          indicatorColor="primary"
          textColor="primary"
        >
          {list.map((item, index) => (
            <Tab
              className={classes.tab}
              key={"TabSelector-" + index + item.id}
              value={item.idCompania ? item.idCompania : item.id}
              label={
                item.nombreCompania
                  ? item.nombreCompania
                  : negociosSegurosOptions[
                      item.id as keyof typeof negociosSegurosOptions
                    ]
              }
            />
          ))}
        </Tabs>
      )}
    </Paper>
  );
};

export default TabSelector;
